import {
    FC,
    HTMLAttributes,
    MouseEvent as ReactMouseEvent,
    ReactNode,
} from 'react';
import clsx from 'clsx';
import BaseCheckbox from 'components/Form/Base/BaseCheckbox';
import Icon from 'components/Icon';
import Pill from 'components/Pill';
import {Status} from 'types';
import {option} from './styles.module.css';
import CLEAR_SELECTION from './types';

type DrawerOptionProps = {
    className?: string;
    disabled?: boolean;
    isCheckable: boolean;
    label: ReactNode;
    onClick?: (event: ReactMouseEvent) => void;
    selected?: boolean;
    status?: Status;
    value: string;
};

const DrawerOption: FC<DrawerOptionProps & HTMLAttributes<HTMLDivElement>> = ({
    className,
    disabled,
    isCheckable,
    label,
    onClick,
    selected,
    status,
    value,
    ...rest
}) => (
    <div
        aria-disabled={!!disabled}
        aria-selected={true}
        className={clsx(
            option,
            value === CLEAR_SELECTION && 'justify-between',
            className,
        )}
        data-selected-single={selected && !isCheckable}
        onClick={disabled ? () => {} : onClick}
        onKeyDown={() => {}}
        role="option"
        tabIndex={0}
        {...rest}
    >
        {isCheckable && (
            <BaseCheckbox
                checked={!!selected}
                className="mt-1 self-start"
                disabled={disabled}
                name={value}
                onChange={() => {}}
            />
        )}
        {label}
        {status && (
            <Pill color={status?.color ?? 'grey'} label={status.label} />
        )}
        {value === CLEAR_SELECTION && <Icon icon="close_small" />}
    </div>
);

export default DrawerOption;
